import * as XLSX from "xlsx";
import {
  AreaExportData,
  ExportFieldVisibility,
  ExportOptions,
  fullExportFieldVisibility,
} from "../types";
import { buildExportDataRows, buildExportHeader } from "./exportHelpers";

function buildExportSheet(
  areas: AreaExportData[],
  vis: ExportFieldVisibility
): XLSX.WorkSheet {
  const header = buildExportHeader(vis);
  if (header.length === 0) {
    throw new Error("No export columns selected.");
  }
  const dataRows = buildExportDataRows(areas, vis);
  const rows: (string | number)[][] = [header, ...dataRows];
  return XLSX.utils.aoa_to_sheet(rows);
}

export async function xlsxExporter(
  areas: AreaExportData[],
  _baseFilename: string,
  options?: ExportOptions
): Promise<Blob> {
  if (areas.length === 0) {
    throw new Error("No areas to export.");
  }

  const vis = fullExportFieldVisibility(options?.fieldVisibility);

  const wb = XLSX.utils.book_new();
  const ws = buildExportSheet(areas, vis);
  XLSX.utils.book_append_sheet(wb, ws, "Export");

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" }) as ArrayBuffer;
  return new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
